import { useEffect } from "react";
import { toast } from "sonner";

export function useIpProtection(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    const warn = () => toast.info("Developer tools disabled in demo mode.");
    const onContext = (e: MouseEvent) => {
      e.preventDefault();
      warn();
    };
    const onKey = (e: KeyboardEvent) => {
      const k = e.key.toLowerCase();
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && (k === "i" || k === "j" || k === "c")) ||
        (e.ctrlKey && k === "u") ||
        (e.metaKey && e.altKey && k === "i")
      ) {
        e.preventDefault();
        warn();
      }
    };
    window.addEventListener("contextmenu", onContext);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("contextmenu", onContext);
      window.removeEventListener("keydown", onKey);
    };
  }, [enabled]);
}

export function isIpProtectionRequested(): boolean {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("demo") === "locked";
}
